import { Component, OnInit, NgModule } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { ReactiveFormsModule, FormControl, FormGroup } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { Observable } from 'rxjs/Observable';
import { map } from 'rxjs/operators/map';
import { startWith } from 'rxjs/operators/startWith';
import Swal from 'sweetalert2';
import { ApiService } from '../../services/api.service';
import { Global } from '../../global';
import { Router } from '@angular/router';
import { FilterPipe } from 'ngx-filter-pipe';


@Component({
  selector: 'app-solicita-troca-escala',
  templateUrl: './solicita-troca-escala.component.html',
  styleUrls: ['./solicita-troca-escala.component.css']
})
export class SolicitaTrocaEscalaComponent implements OnInit {

  escolheData: boolean = false;
  loading: boolean = false;
  currentUser: any = {};
  filtro: any = {};
  filtroSelecionado: any = {};
  solicita: any = {};
  listaUnidades: any = [];
  listaSetores: any = [];
  listaFuncionarios: any = [];
  listaEscalaAssumir: any = [];
  listaEscalaRepassar: any = [];
  setor: any = {};
  escalas: any = {};
  listaRequisicoes: any = [];
  filtro_historico: any = {};

  constructor(
    private apiService: ApiService,
    public global: Global,
    public dialog: MatDialog,
    private router: Router,
    private filter: FilterPipe
  ) {
    try {
      if (localStorage.getItem("currentUser") == null)
        this.router.navigate(["/login"]);
      this.currentUser = JSON.parse(localStorage.getItem("currentUser"));
    } catch (err) {
      this.router.navigate(["/login"]);
    }
  }

  ngOnInit() {
    this.obterUnidades();
    this.obterRequisicoes();
  }

  obterRequisicoes() {
    this.loading = true;
    this.apiService.Get("TrocaEscalas").then(
      result => {
        this.listaRequisicoes = result;
        console.log(this.listaRequisicoes);
        for (var i = 0; i < this.listaRequisicoes.length; i++) {
          var mes = this.listaRequisicoes[i].escala_requisitada_data_escala.split("-")[1];
          var ano = this.listaRequisicoes[i].escala_requisitada_data_escala.split("-")[0];
          this.listaRequisicoes[i].mes = mes;
          this.listaRequisicoes[i].ano = ano;
        }
      },
      err => {
        if (err.status == 401) {
          this.router.navigate(["/login"]);
          this.loading = false;
          return;
        }
        Swal.fire({
          type: 'error',
          title: 'Oops...',
          text: err.error.mensagem
        });
      }
    );
    this.loading = false;
  }

  mudaEscala(funcionario) {
    funcionario.assumir = null
    this.escolheData = !this.escolheData;
    this.listaEscalaAssumir = null;
  }

  deleteFuncAtual() {
    for (var i = 0; i < this.listaFuncionarios.length; i++) {
      if (this.listaFuncionarios[i].uuid == this.currentUser.uuid) {
        this.listaFuncionarios.splice(i, 1);
        return;
      }
    }
  }


  obterFuncionarios() {
    this.loading = true;
    if (this.validoFiltro()) {
      this.filtroSelecionado = this.filtro;
      this.apiService.Get("Funcionarios?setor_uuid=" + this.filtroSelecionado.setor).then(
        result => {
          this.listaFuncionarios = result;
          this.obterEscalasRepassar(this.currentUser.uuid, this.filtroSelecionado.setor);
          this.deleteFuncAtual();
        },
        err => {
          if (err.status == 401) {
            this.router.navigate(["/login"]);
            this.loading = false;
            return;
          }
          Swal.fire({
            type: 'error',
            title: 'Oops...',
            text: err.error.mensagem
          });
        }
      );
    }
    this.loading = false;
  }

  obterUnidades() {
    this.loading = true;
    this.apiService.Get("Unidades").then(
      result => {
        this.listaUnidades = result;
      },
      err => {
        if (err.status == 401) {
          this.router.navigate(["/login"]);
          this.loading = false;
          return;
        }
        Swal.fire({
          type: 'error',
          title: 'Oops...',
          text: err.error.mensagem
        });
      }
    );
    this.loading = false;
  }

  obterSetores(unidade_id) {
    if (unidade_id == 0) {
      this.listaSetores = null;
      return;
    }
    this.loading = true;
    this.apiService.Get("Unidades/" + unidade_id + "/Setores?ativo=true").then(
      result => {
        this.listaSetores = result;
        this.setor = null;
        this.loading = false;
      },
      err => {
        if (err.status == 401) {
          this.router.navigate(["/login"]);
          this.loading = false;
          return;
        }
        this.loading = false;
        Swal.fire({
          type: 'error',
          title: 'Oops...',
          text: err.error.mensagem
        });
      }
    );
  }

  validoFiltro() {
    if (this.filtro.unidade == null || this.filtro.unidade == "" || this.filtro.unidade == 0) {
      Swal.fire({
        type: 'error',
        title: 'Oops...',
        text: 'Insira a unidade!'
      });
      return false;
    }
    if (this.filtro.setor == null || this.filtro.setor == "" || this.filtro.setor == 0) {
      Swal.fire({
        type: 'error',
        title: 'Oops...',
        text: 'Insira o setor!'
      });
      return false;
    }
    return true;
  }

  validoSolicitar(funcionario) {
    if (funcionario.assumido == null || funcionario.assumido == "" || funcionario.assumido == 0) {
      Swal.fire({
        type: 'error',
        title: 'Oops...',
        text: 'Insira uma escala para assumir!'
      });
      return false;
    }
    if (funcionario.repassar == null || funcionario.repassar == "" || funcionario.repassar == 0) {
      Swal.fire({
        type: 'error',
        title: 'Oops...',
        text: 'Insira uma escala para repassar!'
      });
      return false;
    }
    return true;
  }

  obterEscalasPossiveis(funcionario) {
    var funcionario_id = funcionario.uuid
    if (funcionario_id == 0 || funcionario_id == null) {
      this.listaEscalaAssumir = null;
      this.solicita = null;
      return;
    }
    this.loading = true;
    this.obterEscalasAssumir(funcionario);
    funcionario.assumir = !funcionario.assumir;
    funcionario.assumido = null;
    funcionario.repassar = null;
    this.escolheData = !this.escolheData;
    this.loading = false;
  }

  obterEscalasAssumir(funcionario) {

    var funcionario_id = funcionario.uuid
    if (funcionario_id == 0 || funcionario_id == null) {
      this.listaEscalaAssumir = null;
      return;
    }
    this.loading = true;
    this.apiService.Get("Funcionarios/" + funcionario_id + "/Escalas?setor_uuid=" + this.filtroSelecionado.setor).then(
      result => {
        this.listaEscalaAssumir = result;
        funcionario.assumido = null;
        funcionario.repassar = null;
        this.loading = false;
      },
      err => {
        if (err.status == 401) {
          this.router.navigate(["/login"]);
          return;
        }
        this.loading = false;
        Swal.fire({
          type: 'error',
          title: 'Oops...',
          text: err.error.mensagem
        });
      }
    );
  }

  obterEscalasRepassar(funcionario_id, setor_uuid) {

    if (funcionario_id == 0 || funcionario_id == null) {
      this.listaEscalaAssumir = null;
      return;
    }
    this.loading = true;
    this.apiService.Get("Funcionarios/" + funcionario_id + "/Escalas?setor_uuid=" + setor_uuid).then(
      result => {
        this.listaEscalaRepassar = result;
        this.loading = false;
      },
      err => {
        if (err.status == 401) {
          this.router.navigate(["/login"]);
          return;
        }
        this.loading = false;
        Swal.fire({
          type: 'error',
          title: 'Oops...',
          text: err.error.mensagem
        });
      }
    );
  }

  pedirMudancaEscala(funcionario) {
    this.loading = true;
    if (this.validoSolicitar(funcionario)) {
      var Obj = {
        funcionario_solicitante_uuid: this.currentUser.uuid,
        escala_atual_uuid: funcionario.repassar,
        funcionario_requisitado_uuid: funcionario.uuid,
        escala_requisitada_uuid: funcionario.assumido
      }
      this.apiService.Post("TrocaEscalas", Obj).then(
        result => {
          //this.listaEscalaAssumir = result;
          this.obterEscalasRepassar(this.currentUser.uuid, this.filtroSelecionado.setor);
          this.obterRequisicoes();
          Swal.fire({
            type: 'success',
            title: 'Sucesso!',
            text: 'Mudança de escala solicitada com sucesso!'
          });
        },
        err => {
          if (err.status == 401) {
            this.router.navigate(["/login"]);
            this.loading = false;
            return;
          }
          this.loading = false;
          Swal.fire({
            type: 'error',
            title: 'Oops...',
            text: err.error.mensagem
          });
        }
      );
     
    }
    else {
      this.loading = false;
    }
    funcionario.assumir = null;
    funcionario.repassar = null;
    //this.loading = false;
  }


  dataFormat(data) {
    return this.global.dateFormater(data);
  }

  pesquisar(item) {
    //if (this.filtro_historico != null && this.filtro_historico.mes != null) {
      //mes do item == filtro historico mes
      //if()
      /// se for
      ///return item
      /// se nao
      ///return;
    //}
    return item;
  }

}



// WEBPACK FOOTER //
// ./src/app/pages/solicita-troca-escala/solicita-troca-escala.component.ts